import { Component, OnInit, ChangeDetectionStrategy, ViewChild, ElementRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import { startOfDay, endOfDay, subDays, addDays, endOfMonth, isSameDay, isSameMonth, addHours } from 'date-fns';

//import services
import { DeadlineService } from '../../../../services/deadline.service';

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
};


@Component({
  selector: 'app-deadline-calendar',
  templateUrl: './deadline-calendar.component.html',
  styleUrls: ['./deadline-calendar.component.css']
})
  
export class DeadlineCalendarComponent implements OnInit {

  lang: any;

  @ViewChild('modalContent') modalContentRef: ElementRef;
  modalData: {event : CalendarEvent};
  modalRef: BsModalRef;
  
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;

  viewDate: Date = new Date();
  activeDayIsOpen: boolean = false;

  events: CalendarEvent[] = [];
  locale: String;
  constructor(
    private modalService: BsModalService,
    private deadlineService: DeadlineService,
  ) { }

  ngOnInit() {
    let defaultLang = localStorage.getItem("lang")
    if(defaultLang == "english") defaultLang = "en"
    else if(defaultLang == "italian") defaultLang = "it"
    else defaultLang = "en"
    
    this.locale = defaultLang
    this.deadlineService.calendar()
      .subscribe(
        (res) => {

          this.lang = this.deadlineService.calendarLang(res);

          let details = res.data.calendar;
          let that = this;
          
          details.forEach(element => {

              that.events.push(
                {
                  start: new Date(element.start.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")),
                  end: new Date(element.end.replace( /(\d{2})-(\d{2})-(\d{4})/, "$2/$1/$3")),
                  title: element.title,
                  meta: {
                    type : element.popup.type,
                    desc : element.popup.description,
                    note : element.popup.renewal_note,
                    created: element.popup.created,
                  },
                  color: colors.red,
                },
              );
          });
          
          

        }
      );

  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  handleEvent(action: string, event: CalendarEvent): void {

    this.modalData = { event: event };
    this.modalRef = this.modalService.show(this.modalContentRef, { class: 'modal-lgs'});

  }

}
